/**
 * Utility for mapping character aptitude ranks (S, A, B...) to visual assets and styles.
 * Centralizes logic previously scattered across AptitudePanel, AptitudeBadge, and CharacterAptitudes.
 */

// Official Rank List
export const APTITUDE_RANKS = ['S', 'A', 'B', 'C', 'D', 'E', 'F', 'G'];

/**
 * Returns the image path for a given rank letter.
 * @param {string} rank - The rank letter (S, A, B...)
 * @returns {string} The path to the image asset
 */
export const getAptitudeImage = (rank) => {
  if (rank && APTITUDE_RANKS.includes(rank)) {
    return `/images/Letras/${rank}.png`;
  }
  return '';
};

/**
 * Returns the Tailwind CSS classes for the AptitudeBadge background/ring.
 * (Logic migrated from AptitudePanel.js)
 */
export const getAptitudeBadgeStyle = (rank) => {
  switch (rank) {
    case 'S': return 'bg-gradient-to-br from-yellow-50 to-yellow-100 ring-yellow-400/50';
    case 'A': return 'bg-gradient-to-br from-rose-50 to-rose-100 ring-rose-400/50';
    case 'B': return 'bg-gradient-to-br from-pink-50 to-pink-100 ring-pink-400/50';
    case 'C': return 'bg-gradient-to-br from-emerald-50 to-emerald-100 ring-emerald-400/50';
    case 'D': return 'bg-gradient-to-br from-sky-50 to-sky-100 ring-sky-400/50';
    case 'E': return 'bg-gradient-to-br from-violet-50 to-violet-100 ring-violet-400/50';
    case 'F': return 'bg-gradient-to-br from-slate-100 to-slate-200 ring-slate-400/50';
    case 'G': return 'bg-gradient-to-br from-gray-100 to-gray-200 ring-gray-400/50';
    default: return 'bg-gray-50 ring-gray-200';
  }
};

/**
 * Returns the Tailwind CSS classes for the Admin Select inputs.
 * (Logic migrated from Admin/Characters/CharacterAptitudes.js)
 */
export const getAptitudeSelectStyle = (rank) => {
  if (['A', 'S'].includes(rank)) {
    return 'border-pink-300 bg-pink-50 text-pink-700 font-bold';
  }
  if (['B', 'C'].includes(rank)) {
    return 'border-green-300 bg-green-50 text-green-700';
  }
  return 'border-gray-300 bg-white text-gray-700';
};

/**
 * Returns the legacy CSS class for a given rank letter.
 */
export const getAptitudeRankClass = (rank) => {
  if (!rank) return '';
  return `apt-rank-${rank.toLowerCase()}`;
};
